var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mail-event-search pa-10"},[_c('title-page',{attrs:{"icon":"mdi-email-multiple"}},[_vm._v(" "+_vm._s(_vm.$t('mail-event.search-mail-events'))+" ")]),_c('mail-event-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }